<template>
  <div class="main-container">
	
	<!-- 修改返回ui 2022年7月15日byzb -->
	<Draggable v-if="!$route.path.startsWith('/home3rd') && $store.state.showBack" :position="backPosition" isFixedLeft>
		<div class="cancel-button" @click="back">
		  返回
		</div>
	</Draggable>

    <router-view v-if="isRouterAlive"></router-view>
    <Draggable v-if="showShortcutButton">
      <div class="box" @click="onTap">
        菜单
      </div>
    </Draggable>
    <Draggable v-if="$store.state.showLoginDraggable">
      <div class="box" @click="onTapLogin">
        {{$store.getters.isGuest ? '登录' : '退出'}}
      </div>
    </Draggable>
    <van-popup
      v-model="show"
      position="top"
      get-container="body"
      :style="{ minHeight: '100px' }">
      <div class="space-menu-popup-container">

        <div
          class="item"
          v-for="item in $store.state.spacePages"
          :key="item.key"
          @click="onClickItem(item)">
          <i :class="item.icon"></i>
          <div class="name">
            {{item.name}}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import Draggable from "./component/Draggable";
  import {setCookie} from "../assets/js/Untis";
  import axios from 'axios'

  export default {
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true,
        show: false,
		backPosition:{
			x: 0,
			y: 30,
		}
      }
    },
    components: {
      Draggable
    },
    created() {
      console.log('location.href', location.href)
      this.$store.dispatch('getSystemConfig')
        .then(() => {
          const url = `${location.origin}${this.$BASE_PATH}/api/personalized/config/get`
          axios.post(url, {}).then(res => {
            return res.data
          }).then(({resultObject, status, info}) => {
            console.log('resultObject---', {resultObject, status, info})
            this.$store.commit('SET_PERSONALIZED_CONFIG', JSON.parse(resultObject.personalizedConfig))
          })
        }).catch(console.error)

      //全局监听，页面刷新的时候将store里state的值存到sessionStorage中，然后从sessionStorage中获取，再赋值给store。然后再把session里面存的删除即可，相当于中间件的作用。
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store")) {
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(sessionStorage.getItem("store"))
          )
        );
        sessionStorage.removeItem("store")
        this.$store.dispatch('actionSetToken')
      }

      //在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload", () => {
        console.log("beforeunload")
        sessionStorage.setItem("store", JSON.stringify(this.$store.state));
      });
      // 兼容移动端，上面方法移动端无效
      window.addEventListener('pagehide', () => {
        console.log("pagehide")
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      })

      console.log('ding---', this.$dd)
      // if (this.$dd) {
      //   this.$dd.ready(() => {
      //     console.log('ding-setTitle--ready', this.$store.getters.pageTitle)
      //     // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
      //     this.$dd.biz.navigation.setTitle({
      //       title: this.$store.getters.pageTitle
      //     })
      //   });
      // }
    },
    computed: {
      showShortcutButton() {
        return !this.$route.path.startsWith('/home3rd') && this.$store.state.showDraggable
      }
    },
    methods: {
      // 刷新方法
      reload: function () {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      },

      onTap() {
        this.show = true
      },

      onClickItem(item) {
        this.show = false
        let index = -1
        this.$store.state.spacePages.forEach((page, idx) => {
          if (page.key === item.key) {
            index = idx
          }
        })
        if (index > 3) {
          sessionStorage.setItem('page_key', item.key)
        } else {
          sessionStorage.removeItem('page_key')
        }
        this.$router.replace(item.route)
      },

      back() {

        if (this.$route.path.startsWith('/home3rd')) {
          return
        }
        this.show = false
        this.$router.go(-1)
      },

      onTapLogin() {
        if (!this.$store.getters.isGuest) {
          this.$dialog.confirm({
            title: '提示',
            message: '是否确定退出？',
          })
            .then(() => {
              // on confirm
              this.$toast.success('退出成功')

              // 清除登录信息
              setCookie('home3rd_login', '', 365)
              window.localStorage.clear()
              window.sessionStorage.clear()

              // 退出webview
              // if (window.isWexin || window.isWxWork) {
              //   window.WeixinJSBridge.call('closeWindow')
              // } else {
              //   location.replace(`${location.origin}/miniapp/#/ymt?key=${this.$store.state.ymtNodeKey}`)
              // }
              const toast = this.$toast.loading()
              this.$store.dispatch('actionDecodeMiniQr', this.$store.state.ymtQrcode)
                .then(res => {
                  location.replace(`${location.origin}${this.$FORWARD_BASE_PATH}/#/ymt/login?qrcode=${this.$store.state.ymtQrcode}&companyId=${res.param.companyId}&recordId=${res.param.recordId}`)
                })
                .catch(console.error)
                .finally(() => {
                  toast.clear()
                })
            })
            .catch(() => {
              // on cancel
            });
        } else {
          const toast = this.$toast.loading()
          this.$store.dispatch('actionDecodeMiniQr', this.$store.state.ymtQrcode)
            .then(res => {
              location.replace(`${location.origin}${this.$FORWARD_BASE_PATH}/#/ymt/login?qrcode=${this.$store.state.ymtQrcode}&companyId=${res.param.companyId}&recordId=${res.param.recordId}`)
            })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        }
      }
    }
  }
</script>

<style lang="less">

  .cancel-button {
    width: 60px;
    height: 30px;
    border-radius: 0 15px 15px 0;
	left: 0;
    background-color: #fff;
    color: #333;
	box-shadow: 0 5px 15px 1px rgba(0,0,0,0.2);
	line-height: 30px;
	text-align: center;
	opacity: 0.9;
	font-size: 13px;
  }

  .space-menu-popup-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 20px;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 60px;
      border: 1px solid #e6e6e6;
      border-radius: 5px;
      margin: 10px;

      i {
        font-size: 22px;
        margin-bottom: 5px;
      }

      .name {
        font-size: 12px;
        color: #333333;
      }
    }
  }
</style>
